/******************************************************************************************
 *	Inline Address Filter
 ******************************************************************************************/
(function() {
  

  // eslint-disable-next-line lodash/prefer-lodash-method
  angular.module('rcFilters.address', []).filter(
    'address',
    /* @ngInject */
    function(_, $sce, $translate, Languages, locale, Utility, Settings) {
      return function(address, inline) {
        if (!address) {
          return '';
        }

        var street1 = Utility.simpleHtmlEscape(address.street1);
        var street2 = Utility.simpleHtmlEscape(address.street2);
        var city = Utility.simpleHtmlEscape(address.city);
        var postalCode = Utility.simpleHtmlEscape(address.postalCode);
        var country = Utility.simpleHtmlEscape(
          address.country.countryName || address.country.countryCode
        );

        //Region is more complicated due to the "default region"
        var region = '';
        if (address.region) {
          if (address.region.regionCode === Settings.DEFAULT_REGION_CODE) {
            region = $translate.instant('generic.defaultRegion');
          } else {
            region = Utility.simpleHtmlEscape(
              address.region.regionName ? address.region.regionName : address.region.regionCode
            );
          }
        }

        //Check if outputs should be inline or not
        var output;
        var street;
        if (inline !== true) {
          street = street1 + (street2 ? '<br/>' + street2 : '');

          //Locale specific formats
          if (Languages.invertAddress()) {
            if (locale.getActiveLocaleCode() === 'zh_CN') {
              // line 1 	postalCode, country, region, city,
              // line 2		street
              output = [
                postalCode + ' ',
                country,
                region || city ? ', ' : null,
                region,
                region && city ? ', ' : null,
                city,
                postalCode || country || city || region ? '<br/>' : null,
                street ? street : null
              ].join('');
            } else {
              // line 1 	postalCode, region, city,
              // line 2		street
              // line 3   country
              output = [
                postalCode,
                region || city ? ', ' : null,
                region,
                region && city ? ', ' : null,
                city,
                postalCode || city || region ? '<br/>' : null,
                street ? street + '<br/>' : null,
                country
              ].join('');
            }
          } else {
            //Default format
            // line 1		street
            // line 2 	city, postalCode
            // line 3   region, country
            output = [
              street ? street + '<br/>' : null,
              city,
              city && postalCode ? ', ' : null,
              postalCode,
              city || postalCode ? '<br/>' : null,
              region ? region + ', ' : null,
              country
            ].join('');
          }
        } else {
          street = street1 + (street2 ? ' ' + street2 : '');

          //Locale specific formats
          if (Languages.invertAddress()) {
            output = [postalCode, region, city, street, country];
          } else {
            //Default format
            output = [street, city, region, postalCode, country];
          }

          //Convert to string, removing falsey elements except 0
          output = _.filter(output, function(item) {
            return item || item === 0;
          }).join(', ');
        }

        return $sce.trustAsHtml(output);
      };
    }
  );
})();
